// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__2fnkz","active":"downloadDropdown_active__2P_kY"};